import { render } from "./FaceQuestionView.vue?vue&type=template&id=dafcfd84"
import script from "./FaceQuestionView.vue?vue&type=script&lang=js"
export * from "./FaceQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__